var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"animated"}},[_c('b-card',[_c('b-card-header',[_c('i',{staticClass:"icon-menu mr-1"}),_vm._v("Data Table Active User Gram Purchase ")]),_c('b-card-body',[_c('gram')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }